import store from '@/store/store'

const CommonHelper = {
    init() {
        this.$store = store
    },
    showLoader() {
        this.$store.commit('SET_LOADER', true)
    },
    hideLoader() {
        this.$store.commit('SET_LOADER', false)
    },
    swal(title, message, type) {
        if (type == 'error' || !type) {
            this.$store.commit('SET_SNACKBAR_ERROR_MESSAGE', message || title)
        } else if (type == 'success') {
            this.$store.commit('SET_SNACKBAR_SUCCESS_MESSAGE', message || title)
        } else if (type == 'warning') {
            this.$store.commit('SET_SNACKBAR_WARNING_MESSAGE', message || title)
        } else if (type == 'info') {
            this.$store.commit('SET_SNACKBAR_INFO_MESSAGE', message || title)
        }
    },
    isDevelopmentEnvironment() {
        if (
            process.env.VUE_APP_IS_DEVELOPMENT &&
            process.env.VUE_APP_IS_DEVELOPMENT == 'true'
        )
            return true
        return false
    },
    isReleaseEnvironment() {
        if (
            process.env.VUE_APP_IS_RELEASE &&
            process.env.VUE_APP_IS_RELEASE == 'true'
        )
            return true
        return false
    },
    isProductionEnvironment() {
        if (
            process.env.VUE_APP_IS_PRODUCTION &&
            process.env.VUE_APP_IS_PRODUCTION == 'true'
        )
            return true
        return false
    },
    clearInputFile(inputFile) {
        //INFELIZMENTE ISSO REALMENTE É NECESSÁRIO NO DIA 08/08/2019. REALMENTE TENTEI!
        inputFile.type = 'text'
        inputFile.type = 'file'
    },
    validateCPF(cpf) {
        if (!cpf) return false

        cpf = cpf.replace(/[^\d]+/g, '')

        var numeros, digitos, soma, i, resultado, digitos_iguais
        digitos_iguais = 1
        if (cpf.length < 11) return false
        for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                digitos_iguais = 0
                break
            }
        if (!digitos_iguais) {
            numeros = cpf.substring(0, 9)
            digitos = cpf.substring(9)
            soma = 0
            for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
            if (resultado != digitos.charAt(0)) return false
            numeros = cpf.substring(0, 10)
            soma = 0
            for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
            if (resultado != digitos.charAt(1)) return false
            return true
        } else return false
    },
    validateCNPJ(cnpj) {
        if (!cnpj) return false

        cnpj = cnpj.replace(/[^\d]+/g, '')

        if (cnpj == '') return false

        if (cnpj.length != 14) return false

        // Elimina CNPJs invalidos conhecidos
        if (
            cnpj == '00000000000000' ||
            cnpj == '11111111111111' ||
            cnpj == '22222222222222' ||
            cnpj == '33333333333333' ||
            cnpj == '44444444444444' ||
            cnpj == '55555555555555' ||
            cnpj == '66666666666666' ||
            cnpj == '77777777777777' ||
            cnpj == '88888888888888' ||
            cnpj == '99999999999999'
        )
            return false

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho)
        let digitos = cnpj.substring(tamanho)
        let soma = 0
        let pos = tamanho - 7
        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) pos = 9
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
        if (resultado != digitos.charAt(0)) return false

        tamanho = tamanho + 1
        numeros = cnpj.substring(0, tamanho)
        soma = 0
        pos = tamanho - 7
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) pos = 9
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
        if (resultado != digitos.charAt(1)) return false

        return true
    },
    validateEmail(email) {
        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regex.test(String(email).toLowerCase())
    },
    validateCellPhone(phone) {
        // var regex = /^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$/
        // var regex = /^(?:\+)[0-9]{2}\s?(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/
        var regex = /^1\d\d(\d\d)?$|^0800 ?\d{3} ?\d{4}$|^(\(0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d\) ?|0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d[ .-]?)?(9|9[ .-])?[2-9]\d{3}[ .-]?\d{4}$/
        if (phone.length < 8) return false
        else if (
            phone == '0000000000' ||
            phone == '00000000000' ||
            phone == '1111111111' ||
            phone == '11111111111' ||
            phone == '2222222222' ||
            phone == '22222222222' ||
            phone == '3333333333' ||
            phone == '33333333333' ||
            phone == '4444444444' ||
            phone == '44444444444' ||
            phone == '5555555555' ||
            phone == '55555555555' ||
            phone == '6666666666' ||
            phone == '66666666666' ||
            phone == '7777777777' ||
            phone == '77777777777' ||
            phone == '8888888888' ||
            phone == '88888888888' ||
            phone == '9999999999' ||
            phone == '99999999999'
        )
            return false
        else return regex.test(String(phone))
    },
    GetEntityAge(entity) {
        let creationDateDayOfTheMonth = new Date(entity.creationDate).getDate()
        let creationDateMonth = new Date(entity.creationDate).getMonth() + 1
        let creationDateYear = new Date(entity.creationDate).getFullYear()

        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()

        let diffYear = yyyy - creationDateYear
        if (diffYear > 0) {
            return diffYear + ' Anos(s) +'
        }

        let diffMonth = mm - creationDateMonth
        if (diffMonth > 0) {
            return diffMonth + ' Mes(es) +'
        }

        return dd - creationDateDayOfTheMonth + ' Dia(s)'
    },
    wordCount(str){
        if (!str) return 0;
        
        return str.split(' ').length;
    }
}

CommonHelper.init()

export default CommonHelper
